<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-trade__boxform}">
      <el-form
          :inline="true"
          :model="dataForm"
          @keyup.enter.native="reload()"
      >
        <el-form-item label="进出口发票号：">
          <el-input v-model="dataForm.receiptCode" placeholder="进出口发票号" size="mini" clearable></el-input>
        </el-form-item>
        <el-form-item label="目的地：">
          <el-input v-model="dataForm.destination" placeholder="目的地" size="mini" clearable></el-input>
        </el-form-item>
        <el-form-item label="装船日期：">
          <el-date-picker
              v-model="dateArr"
              type="daterange"
              range-separator="至"
              value-format="yyyy-MM-dd"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              size="mini"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button @click="getDataList()" size="mini">{{ $t('query') }}</el-button>
        </el-form-item>

        <el-form-item>
          <el-button
              icon="el-icon-plus"
              v-if="$hasPermission('trade:boxform:save')"
              type="primary"
              @click="showCreateOutletBox"
              size="mini">创建出口发票
          </el-button>
          <el-button
              icon="el-icon-plus"
              v-if="$hasPermission('send:batch')"
              type="primary"
              @click="showOrderSendImportDialog"
              size="mini">批量导入出口发票
          </el-button>
        </el-form-item>
        <!--        <el-form-item>-->
        <!--          <el-button-->
        <!--              :disabled="true"-->
        <!--              size="mini"-->
        <!--              icon="el-icon-upload"-->
        <!--              @click="showCommonDialog()"-->
        <!--              type="warning"-->
        <!--              v-if="$hasPermission('send:batch')"-->
        <!--          >批量导入(升级中,暂停使用)-->
        <!--          </el-button>-->
        <!--        </el-form-item>-->
      </el-form>
      <el-table
          v-loading="dataListLoading"
          :data="dataList"
          border
          @selection-change="dataListSelectionChangeHandle"
          style="width: 100%;"
      >
        <el-table-column
            type="index"
            label="行号"
            header-align="center"
            align="center"
            width="50"
        ></el-table-column>
        <el-table-column
            prop="receiptCode"
            label="进出口发票号"
            header-align="center"
            align="center"
        ></el-table-column>
        <el-table-column
            prop="customerName"
            label="客户"
            header-align="center"
            align="center"
        ></el-table-column>
        <el-table-column
            prop="vesselName"
            label="船名"
            header-align="center"
            align="center"
        ></el-table-column>
        <el-table-column
            prop="shipDate"
            label="装船日期"
            header-align="center"
            align="center"
            width="160px"
        ></el-table-column>
        <el-table-column
            prop="fromHarbour"
            label="出发港"
            header-align="center"
            align="center"
        ></el-table-column>
        <el-table-column
            prop="destination"
            label="目的港"
            header-align="center"
            align="center"
        ></el-table-column>
        <el-table-column
            prop="creatorName"
            label="制单人"
            header-align="center"
            align="center"
            width="160px"
        ></el-table-column>
        <el-table-column
            prop="createDate"
            label="制单时间"
            header-align="center"
            align="center"
            width="160px"
        ></el-table-column>
        <el-table-column
            :label="$t('handle')"
            fixed="right"
            header-align="center"
            align="center"
            width="300"
        >
          <template slot-scope="scope">
            <el-button
                icon="el-icon-edit"
                v-if="$hasPermission('box:form:update')"
                type="text"
                size="small"
                @click="showDestinationDialog(scope.row)"
            >调整目的港
            </el-button>
            <el-button
                icon="el-icon-edit"
                v-if="$hasPermission('box:form:update')"
                type="text"
                size="small"
                @click="showCreateOutletBox(scope.row)"
            >修改
            </el-button>
            <el-button
                icon="el-icon-download"
                type="text"
                size="small"
                @click="downReceipt(scope.row)"
            >发票下载
            </el-button>
            <el-button
                icon="el-icon-close"
                v-if="$hasPermission('box:form:delete')"
                type="text"
                size="small"
                @click="doDel(scope.row)"
            >{{ $t('delete') }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
          :current-page="page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="limit"
          :total="total"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="pageSizeChangeHandle"
          @current-change="pageCurrentChangeHandle"
      >
      </el-pagination>
      <!-- 弹窗, 新增 / 修改 -->
    </div>
    <common-upload
        ref="commonUpload"
        @success="uploadSuccessHandler"
        uploadUrl="/erp/box/import/batch"
        templateUrl="/static/template/发货批量导入.xlsx"
        title="箱单批量导入"
        version="v2"
        :tip-type="2"
    ></common-upload>
    <CreateOutletBox ref="CreateOutletBox" @changed="getDataList"></CreateOutletBox>
    <OrderSendImportDialog ref="OrderSendImportDialog" @changed="getDataList"></OrderSendImportDialog>
    <DestinationDialog ref="destinationDialogRef" @changed="getDataList"></DestinationDialog>
  </el-card>
</template>

<script>
import DestinationDialog from '@/views/modules/erp/box/destination-dialog.vue'
import OrderSendImportDialog from '@/views/modules/erp/box/order-send-import-dialog.vue'
import CreateOutletBox from '@/views/modules/erp/box/CreateOutletBox.vue'
import mixinViewModule from '@/mixins/view-module'
import qs from 'qs'
import Cookies from 'js-cookie'

export default {
  mixins: [mixinViewModule],
  components: { CreateOutletBox, OrderSendImportDialog,DestinationDialog },
  data () {
    return {
      dateArr: [],
      mixinViewModuleOptions: {
        getDataListURL: '/box/form/page',
        getDataListIsPage: true,
        deleteURL: '/box/form',
        deleteIsBatch: false,
      },
      dataForm: {
        receiptCode: '',
        beginDate: '',
        endDate: '',
        destination: '',
        formType: 'outlet'
      },
    }
  },
  watch: {
    dateArr (newVal) {
      if (newVal && newVal.length === 2) {
        this.dataForm.beginDate = newVal[0]
        this.dataForm.endDate = newVal[1]
      } else {
        this.dataForm.beginDate = ''
        this.dataForm.endDate = ''
      }
      this.currentId = ''
      this.reload()
    },
  },
  methods: {
    showDestinationDialog(row){
      this.$refs.destinationDialogRef.open(row.id,row.destination,row.receiptCode)
    },
    showOrderSendImportDialog () {
      this.$refs.OrderSendImportDialog.init()
    },
    showCreateOutletBox (row) {
      if (row) {
        this.$refs.CreateOutletBox.id = row.id
      }
      this.$refs.CreateOutletBox.init()
    },
    doDel (row) {
      this.$confirm(`是否删除进出口发票为【${row.receiptCode}】的箱单`).then(() => {
        this.$api2.delete(`/erp/box/${row.id}`).then(res => {
          this.$message.success('删除成功')
          this.getDataList()
        })
      })
    },
    doRepair (row) {
      this.$api.post(`/trade/boxform/send/additional`, { id: row.id }).then(res => {
        this.$message.success('操作成功')
      })
    },
    uploadSuccessHandler () {
      this.reload()
    },
    //显示通用导入弹窗
    showCommonDialog () {
      this.$refs.commonUpload.init()
    },
    downReceipt (row) {
      var params = qs.stringify({
        token: Cookies.get('token'),
        id: row.id,
      })
      let url = `${window.SITE_CONFIG['apiURL']}/box/form/export/box/receipt?${params}`
      window.open(url, '_blank')
    },
    addOrUpdateHandle (row) {
      let path = `/erp/box/save`
      if (row) {
        path += `?id=${row.id}`
      }
      this.$router.push(path)
    }
  },
}
</script>
